export const ONE_TB_IN_BYTES = 1099511627776
export const ONE_GB_IN_BYTES = 1073741824
export const ONE_MB_IN_BYTES = 1048576
export const ONE_KB_IN_BYTES = 1024
